module.exports = __webpack_public_path__ + "public/images/Illustration_Writing_200x174.08dd435e3c9bbb1b7fd01656497ff2e5.png";